import { createAction } from '@lingoda/core';

export const markSeenNotifications = createAction('notifications/MARK_SEEN_NOTIFICATIONS');
